// extracted by mini-css-extract-plugin
module.exports = {"dashedTopSeparator":"separator_dashedTopSeparator__zPXLu"};